import React from 'react';
const ReactMarkdown = require('react-markdown');

class JobTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
                            expandedRows : [],
        };

    }

    handleRowClick(rowId) {
                const currentExpandedRows = this.state.expandedRows;
                const isRowCurrentlyExpanded = currentExpandedRows.includes(rowId);

                const newExpandedRows = isRowCurrentlyExpanded ?
                        currentExpandedRows.filter(id => id !== rowId) :
                        currentExpandedRows.concat(rowId);

                this.setState({expandedRows : newExpandedRows});

    }

    renderItem(item) {
        const clickCallback = () => this.handleRowClick(item.id);
        const itemRows = [
                        <tr onClick={clickCallback} key={"row-data-" + item.id}>
                            <td>{item.id}</td>
                            <td>{item.Title}</td>
                            <td>{item.Location}</td>
                            <td>{item.Hours}</td>
                            <td>{item.Industry}</td>
                        </tr>

        ];

        if(this.state.expandedRows.includes(item.id)) {
            itemRows.push(
                                <tr className="expanded" key={"row-expanded-" + item.id}>
                                    <td colSpan="5"><div><ReactMarkdown source = {item.Description}/></div></td>
                                </tr>

            );

        }

                return itemRows;

    }

    render() {
        if(Object.keys(this.props.data).length === 0){
            return (<div id="infoText"><p>No roles to show right now. Check back here soon!</p></div>);
        }

        let allItemRows = [];

        this.props.data.forEach(item => {
                        const perItemRows = this.renderItem(item);
                        allItemRows = allItemRows.concat(perItemRows);

        });

        return (
                <table>
                    <thead>
                        <tr key="row-data-0">
                            <td>ID</td>
                            <td>Title</td>
                            <td>Location</td>
                            <td>Hours</td>
                            <td>Industry</td>
                        </tr>
                    </thead>
                    <tbody>
                        {allItemRows}
                    </tbody>
                </table>

        );

    }

}
export default JobTable;
